import App from '../client/containers/App';
import React from 'react';
import MyApps from '../client/containers/MyApps';
import AppCenter from '../client/containers/AppCenter';
import AppDetailPage from '../client/containers/AppDetailPage';
import { tabRouteNames, PARTNERS } from '../client/lib/constants';
import makeAppCenterRoutes from '../server/lib/makeAppCenterRoutes';
import appCenterSchema from '../schema/appcenter';
import Quiz from '../client/containers/Quiz';
import OtssConnect from '../client/containers/OtssConnect';
import NotFound from '../client/components/NotFound';
import AppError from '../client/components/AppError';
import ProductBundle from '../client/containers/covid/ProductBundle';

export default [
  {
    path: '/',
    component: App,
    routes: []
      .concat(
        tabRouteNames.map(route => ({
          path: route,
          component: MyApps,
          exact: true
        }))
      )
      .concat(
        PARTNERS.map(partner => ({
          exact: true,
          path: `sell/${partner}`,
          render: props => <AppDetailPage partner={partner} {...props} />
        }))
      )
      .concat(makeAppCenterRoutes(appCenterSchema, AppCenter))
      .concat({
        path: 'appcenter',
        component: AppCenter,
        exact: true
      })
      .concat({
        path: 'setup-recommendations',
        component: Quiz,
        exact: true
      })
      .concat({
        path: 'walmart-connect',
        component: OtssConnect,
        exact: true
      })
      .concat({
        path: 'error',
        component: AppError,
        exact: true
      })
      .concat({
        path: 'product-bundle',
        component: ProductBundle
      })
      .map(route => {
        route.path = '/' + route.path;
        return route;
      })
      .concat({
        path: '*',
        component: NotFound
      })
  }
];
